"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROFILE_GENDER_OPTIONS = exports.headers = void 0;
exports.headers = {
    BP_TOKEN: "x-bp-token",
    BP_TOKEN_TTL: "x-bp-token-ttl",
    BP_REFRESH_TOKEN_TTL: "x-bp-refresh-token-ttl",
    BP_NEW_BASKET_BACKEND: "x-bp-new-basket-backend",
    BP_PREVIOUS_BASKET_BACKEND: "x-bp-previous-basket-backend",
    BP_REMOTE_LOGOUT: "x-remote-logout",
    BP_CORRELATION_ID: "x-bp-correlation-id",
    BP_API_KEY: "x-bp-api-key",
};
exports.PROFILE_GENDER_OPTIONS = [
    "male",
    "female",
    "nonBinary",
    "notSpecified",
];
//# sourceMappingURL=constants.js.map